import React, {Component} from 'react'
import {Box} from "@material-ui/core/index";
import {PedidosOperation} from 'components/ventas/pedidos/operation/pedidos.operation';
import {ClientesService, CotizacionesService, EmailService, MastersService, PedidosService, VendedoresService} from "services";
import {calcImporteByArticulo} from 'assets/utils';
import MomentUtils from "@date-io/moment/build/index";
import 'moment/locale/es';
import {MainContext} from "contexts/main.context";
import {withSnackbar} from "notistack";
import {MailDialog} from "components/helpers/dialogs/mail.dialog";
import SpeedDial from "@material-ui/lab/SpeedDial/SpeedDial";
import SpeedDialAction from "@material-ui/lab/SpeedDialAction/SpeedDialAction";
import PDFIcon from "@material-ui/icons/PictureAsPdf";
import DownloadIcon from "@material-ui/icons/GetAppRounded";
import ShowIcon from "@material-ui/icons/DesktopWindowsRounded";
import PrintIcon from "@material-ui/icons/PrintRounded";
import EmailIcon from "@material-ui/icons/EmailRounded";
import printJS from 'print-js'
import {PDFDialog} from "components/helpers/dialogs/pdf.dialog";

export class PedidosView extends Component {
    state = {
        cliente: {},
        vendedor: {},
        pedidos: [],
        id: this.props.match.params.pedido,
        condComerciales: [],
        vendedores: [],
        tipoasientos: [],
        talfacturas: [],
        talremitos: [],
        jurisdicciones: [],
        transportes: [],
        headerData: {
            bonificacion: 0,
            listaprecio: '1',
            condcomercial: '',
            notacompra: '',
            usuario: '',
            vendedor: '',
            ingreso: (new MomentUtils()).date(new Date()),
            entrega: (new MomentUtils()).date(new Date()),
            leyenda1: '',
            leyenda2: '',
            leyenda3: '',
            leyenda4: '',
            tipoasiento: '',
            talfactura: '',
            talremito: '',
            jurisdiccion: '',
            transporte: '',
            isPrepago: false,
            condvta30: false
        },
        selectedArticulos: [],
        generatedId: '',
        importes: {
            subtotal: 0,
            bonificado: 0,
            gravado: 0,
            iva: 0,
            iibb: 0,
            total: 0,
            totalPrepago: 0,
            exento: 0,
            interes: 0,
            flete: 0
        },
        importe: 0,
        confirmationDialogOpen: false,
        successDialogOpen: false,
        pdfBlob: null,
        pdfUrl: '',
        mailDialogOpen: false,
        pdfDialogOpen: false,
        dialOpen: false,
    };

    CotizacionesService = new CotizacionesService(this.context);
    PedidosService = new PedidosService(this.context);
    MastersService = new MastersService(this.context);
    VendedoresService = new VendedoresService(this.context);
    ClientesService = new ClientesService(this.context);
    EmailService = new EmailService(this.context);

    componentDidMount() {
        this.ClientesService.getById(
            this.props.match.params.cliente,
            response => this.setState({cliente: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.PedidosService.getByCliente(
            this.props.match.params.cliente,
            response => this.setState({pedidos: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.loadPedidoData();

        this.MastersService.getCondicionesVenta(
            response => this.setState({condComerciales: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.MastersService.getTiposDeAsiento(
            response => this.setState({tipoasientos: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.MastersService.getTalonariosFactura(
            response => this.setState({talfacturas: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.MastersService.getTalonariosRemito(
            response => this.setState({talremitos: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.MastersService.getJurisdicciones(
            response => this.setState({jurisdicciones: response.data.result}),
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );
    }

    loadPedidoData = () => {
        this.PedidosService.getById(
            this.state.id,
            response => {
                const {...res} = response.data.result;
                const headerData = {
                    bonificacion: res.bonificacion || 0,
                    listaprecio: res.listaprecio || '1',
                    condcomercial: res.condcomercial || '1',
                    notacompra: res.notacompra || '',
                    usuario: res.usuario || '',
                    vendedor: res.vendedor && res.vendedor > 0 ? res.vendedor : '',
                    ingreso: res.ingreso ? (new MomentUtils()).parse(res.ingreso, 'D/MM/Y') : '',
                    entrega: res.entrega ? (new MomentUtils()).parse(res.entrega, 'D/MM/Y') : '',
                    leyenda1: res.leyenda1 || '',
                    leyenda2: res.leyenda2 || '',
                    leyenda3: res.leyenda3 || '',
                    leyenda4: res.leyenda4 || '',
                    talfactura: res.talfactura || '',
                    talremito: res.talremito || '',
                    tipoasiento: res.tipoasiento || '',
                    jurisdiccion: res.jurisdiccion || '',
                    transporte: res.transporte || '',
                    estado: res.estado,
                    estadio: res.estadio,
                    isPrepago: res.isprepago,
                    condvta30: res.condvta30
                };
                this.setState({headerData});
                this.setState({importe: parseFloat(res.importe)});

                if (res.isprepago) {
                    this.CotizacionesService.getById(res.idcotiza,
                        response => {
                            const {..._res} = response.data.result;
                            this.CotizacionesService.getImpuestosById(
                                res.idcotiza,
                                response => {
                                    const impuestos = response.data.result.filter(impuesto => parseInt(impuesto.alicuota) !== 0 && parseInt(impuesto.alicuota) !== 1);
                                    this.setState(prevState => {
                                        prevState.impuestos = impuestos;
                                        prevState.importes = prevState.importes || {};
                                        let importes = prevState.importes;
                                        importes.subtotal = _res.impsubtotal;
                                        importes.bonificado = _res.impbonifica;
                                        importes.gravado = _res.impgravado;
                                        importes.iva = _res.impiva;
                                        importes.total = _res.imptotal;
                                        importes.exento = _res.impexento;
                                        importes.interes = _res.impinteres;
                                        importes.flete = _res.impflet;
                                        importes.iibb = impuestos.reduce((sum, impuesto) => sum + parseFloat(impuesto.importe), 0);
                                        importes.totalPrepago = importes.total * (1 - 0.3);
                                        return prevState;
                                    });
                                }
                            )
                        }
                    )
                }

                this.VendedoresService.getById(
                    res.vendedor,
                    response => this.setState({vendedor: response.data.result}),
                    error => this.props.enqueueSnackbar(error, {variant: 'error'})
                )
            },
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );

        this.PedidosService.getArticulosById(
            this.state.id,
            response => {
                let articulos = response.data.result;
                articulos.forEach(articulo => articulo.importe = calcImporteByArticulo(articulo.cantidad, articulo.precio, articulo.bonificacion));
                this.setState({
                    selectedArticulos: articulos,
                    totalArticulos: articulos.reduce((count, articulo) => (count + parseInt(articulo.cantidad)), 0)
                });
            },
            error => this.props.enqueueSnackbar(error, {variant: 'error'})
        );
    };

    onChangeDocument = id => this.setState({id, pdfBlob: null}, () => this.loadPedidoData());

    getPDF = (fnSuccess = () => {
    }) => {
        if (this.state.pdfBlob != null)
            fnSuccess();
        else
            this.PedidosService.getPDF(
                this.state.id,
                file => this.setState({pdfBlob: file}, fnSuccess),
                error => this.props.enqueueSnackbar(error, {variant: 'error'})
            )
    };

    // Show PDF
    onOpenPdfDialog = () => this.setState({pdfDialogOpen: true});
    onClosePdfDialog = () => this.setState({pdfDialogOpen: false});

    onShowPDF = () => {
        this.getPDF(
            () => {
                const fileURL = URL.createObjectURL(this.state.pdfBlob);
                this.setState({pdfUrl: fileURL}, this.onOpenPdfDialog);
                // window.open(fileURL);
            }
        );
    };

    // Print PDF
    onPrintPDF = () => {
        this.getPDF(
            () => {
                const fileURL = URL.createObjectURL(this.state.pdfBlob);
                printJS(fileURL);
            }
        );
    };

    // Download PDF
    onDownloadPdf = () => {
        this.getPDF(
            () => {
                const fileURL = URL.createObjectURL(this.state.pdfBlob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.href = fileURL;
                a.download = `Pedido ${this.state.id}`;
                a.click();
                window.URL.revokeObjectURL(fileURL);
            }
        );
    };

    // Email
    onOpenMailDialog = () => this.setState({mailDialogOpen: true});

    dialActions = [
        {icon: <EmailIcon/>, name: 'Enviar por Email', action: this.onOpenMailDialog},
        {icon: <PrintIcon/>, name: 'Imprimir', action: this.onPrintPDF},
        {icon: <DownloadIcon/>, name: 'Descargar', action: this.onDownloadPdf},
        {icon: <ShowIcon/>, name: 'Ver en Pantalla', action: this.onShowPDF},
    ];

    onCloseMailDialog = () => this.setState({mailDialogOpen: false});

    sendMail = mailData => {
        let sendMail = () => {
            // Paso los parámetros a un formData para poder enviar el blob (attachment)
            var formData = new FormData();
            formData.append('attachment', this.state.pdfBlob);
            formData.append('data', JSON.stringify(mailData));

            this.EmailService.send(
                formData,
                response => {
                    this.onCloseMailDialog();
                    this.props.enqueueSnackbar('El email se envió correctamente', {variant: 'success'});
                },
                error => this.props.enqueueSnackbar(error, {variant: 'error'})
            );
        };

        if (mailData.attachFile)
            this.getPDF(() => sendMail());
        else
            sendMail();
    };

    onDialOpen = () => this.setState({dialOpen: true});

    onDialClose = () => this.setState({dialOpen: false});

    render() {
        const {
            cliente, vendedor, pedidos, id, condComerciales, vendedores, talfacturas, talremitos, tipoasientos, jurisdicciones, transportes, articulos, headerData,
            selectedArticulos, generatedId, importe, importes, totalArticulos, mailDialogOpen, pdfDialogOpen, pdfUrl, dialOpen
        } = this.state;

        const importeBonificado = importe - importe * headerData.bonificacion / 100;

        return (
            <React.Fragment>
                <Box className='niquel-pedidos-view'>
                    <PedidosOperation
                        operation='VIEW'
                        cliente={cliente}
                        pedidos={pedidos}
                        id={id}
                        condComerciales={condComerciales}
                        vendedores={vendedores}
                        talfacturas={talfacturas}
                        talremitos={talremitos}
                        tipoasientos={tipoasientos}
                        jurisdicciones={jurisdicciones}
                        transportes={transportes}
                        articulos={articulos}
                        headerData={headerData}
                        selectedArticulos={selectedArticulos}
                        generatedId={generatedId}
                        importe={importe}
                        importes={importes}
                        totalArticulos={totalArticulos}
                        importeBonificado={importeBonificado}
                        onChangeDocument={this.onChangeDocument}
                    />
                    <Box className='niquel-fab-btn'>
                        <SpeedDial
                            ariaLabel="opciones_pedido"
                            icon={<PDFIcon/>}
                            onBlur={this.onDialClose}
                            onClick={this.onDialOpen}
                            onClose={this.onDialClose}
                            onFocus={this.onDialOpen}
                            onMouseEnter={this.onDialOpen}
                            onMouseLeave={this.onDialClose}
                            open={dialOpen}
                        >
                            {this.dialActions.map(action => (
                                <SpeedDialAction
                                    key={action.name}
                                    icon={action.icon}
                                    tooltipTitle={action.name}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        action.action()
                                    }}
                                />
                            ))}
                        </SpeedDial>
                    </Box>
                </Box>
                <MailDialog
                    open={mailDialogOpen}
                    onConfirm={this.sendMail}
                    onCancel={this.onCloseMailDialog}
                    fileName={`Pedido_${this.state.id}.pdf`}
                    attachFile={true}
                    to={cliente.email}
                    cc={vendedor.email}
                    ccEnabled={true}
                    subject={`Pedido ${this.state.id}`}
                    body={`Estimado cliente,  \n\nSe adjunta el pedido número ${this.state.id}.`}
                />
                <PDFDialog
                    open={pdfDialogOpen}
                    onClose={this.onClosePdfDialog}
                    pdfUrl={pdfUrl}
                    pdfName={`Pedido_${this.state.id}.pdf`}
                />
            </React.Fragment>
        )
    }
}

PedidosView.contextType = MainContext;
PedidosView = withSnackbar(PedidosView);
